import React, { useEffect, useState } from "react";
import { Button, Container, Form, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiRegisterColidee, apiValideActivationColidee } from "../../api/ApiAuthentification";
import logoEasyGouv from "../../assets/images/logoEasyGouv.png";
import ReCAPTCHA from "react-google-recaptcha";
import ComponentLoader from "../../components/layout/ComponentLoader";

export const PageRegister = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [error, setError] = useState("");
  const [errorRegister, setErrorRegister] = useState("");
  const [successRegister, setSuccessRegister] = useState("");
  const [captchaResult, setCaptchaResult] = useState();
  const [loader, setLoader] = useState(false);
  const [loaderActivation, setLoaderActivation] = useState(false);
  const [containerActivation, setContainerActivation] = useState(false);

  const toHome = () => {
    navigate("/");
  };

  const controleFormulaire = async (e) => {
    e.preventDefault();
    setLoader(true);

    let erreurs = {
      nomEmpty: "",
      prenomEmpty: "",
      emailEmpty: "",
      passwordEmpty: "",
      passwordControl: "",
    };
    let formValide = true;

    if (!nom) {
      erreurs.nomEmpty = t("public.pageRegister.errorNom");
      formValide = false;
    }
    if (!prenom) {
      erreurs.prenomEmpty = t("public.pageRegister.errorPrenom");
      formValide = false;
    }
    if (!email) {
      erreurs.emailEmpty = t("public.pageRegister.errorEmail");
      formValide = false;
    }
    if (!password) {
      erreurs.passwordEmpty = t("public.pageRegister.errorPassword");
      formValide = false;
    }
    if (password && password !== passwordConfirm) {
      erreurs.passwordControl = t("public.pageRegister.errorPasswordConfirm");
      formValide = false;
    }

    setError(erreurs);
    /* le formulaire ne compore pas d'erreurs alors on envoi la demande de création de compte à Colidée */
    if (formValide) {
      setErrorRegister("");
      const form = new FormData();
      form.append("racine", process.env.REACT_APP_URL_EASYGOUV);
      form.append("nom", nom);
      form.append("prenom", prenom);
      form.append("email", email);
      form.append("password", password);
      form.append("g-recaptcha-response", captchaResult);
      const res = await apiRegisterColidee(form);

      if (!res.status || res.status === 403) {
        setLoader(false);
        setErrorRegister(res.data.erreur);
        return;
      }

      if (res.status && res.status === 200) {
        setLoader(false);
        setSuccessRegister(res.data.sucess);
        return;
      }
    }
    setLoader(false);
  };

  const handleRecaptcha = (value) => {
    setCaptchaResult(value);
  };

  const valideActivation = async (code) => {
    const res = await apiValideActivationColidee(code);
    if (!res.status || res.status === 403) {
      setLoaderActivation(false);
      setSuccessRegister("");
      setErrorRegister("La validation du compte a échouée.");
    }

    if (res.status && res.status === 200) {
      setErrorRegister("");
      setLoaderActivation(false);
      setSuccessRegister(true);
      return;
    }
  };

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const codeActivation = params.get("a");
    if (codeActivation) {
      setLoaderActivation(true);
      setContainerActivation(true);
      valideActivation(codeActivation);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ height: "100%" }}
    >
      <div className="text-center loginForm mt-5" style={{ width: "400px" }}>
        {containerActivation && (
          <>
            <div className=" bg-primary  p-4 rounded">
              <div>
                <Image src={logoEasyGouv} className="mb-2" onClick={toHome} role="button" />
              </div>
              {loaderActivation && (
                <div className="text-light mt-3">
                  Activation en cours, merci de patienter
                  <br /> <br />
                  <ComponentLoader className="text-light" />
                </div>
              )}
              {errorRegister ? <div className="text-danger">{errorRegister}</div> : ""}
              {successRegister && (
                <div className="text-light">
                  <h3>Compte activé</h3>
                  <a href="/" className="text-light">
                    cliquez-ici pour vous connecter
                  </a>
                </div>
              )}
            </div>
          </>
        )}
        {!containerActivation && (
          <>
            <Form className=" bg-primary  p-4 rounded" onSubmit={controleFormulaire}>
              <div>
                <Image src={logoEasyGouv} className="mb-5" onClick={toHome} role="button" />
              </div>
              {successRegister && (
                <div className="text-light">
                  <h3>Votre compte a bien été créé.</h3>
                  Vous allez recevoir d'ici quelques minutes un lien d'activation à l'adresse mail
                  saisie lors de l'ouverture de votre compte
                  <br />
                  <br />
                  <hr />
                  <br />
                  <br />
                  NOTE IMPORTANTE :<br />
                  Dans certains cas, le lien arrive dans le dossier des courriers indésirables
                  (SPAM) de votre messagerie. <br />
                  Nous vous prions de nous excuser pour cette situation indépendante de notre
                  volonté
                </div>
              )}
              {!successRegister && (
                <>
                  <Form.Control
                    type="text"
                    value={nom}
                    placeholder={t("commun.form.placeholder.placeholderNomConnexion")}
                    onChange={(e) => setNom(e.target.value)}
                    className="p-2"
                  />
                  {error.nomEmpty ? <div className="text-danger">{error.nomEmpty} </div> : ""}
                  <Form.Control
                    type="text"
                    value={prenom}
                    placeholder={t("commun.form.placeholder.placeholderPrenomConnexion")}
                    onChange={(e) => setPrenom(e.target.value)}
                    className="p-2 mt-3"
                  />
                  {error.prenomEmpty ? <div className="text-danger">{error.prenomEmpty} </div> : ""}
                  <Form.Control
                    type="email"
                    value={email}
                    placeholder={t("commun.form.placeholder.placeholderEmailRegister")}
                    onChange={(e) => setEmail(e.target.value)}
                    className="p-2 mt-3"
                  />
                  {error.emailEmpty ? <div className="text-danger">{error.emailEmpty} </div> : ""}
                  <Form.Control
                    type="password"
                    value={password}
                    placeholder={t("commun.form.placeholder.placeholderMdpRegister")}
                    onChange={(e) => setPassword(e.target.value)}
                    className="p-2 mt-3"
                  />
                  {error.passwordEmpty ? (
                    <div className="text-danger">{error.passwordEmpty} </div>
                  ) : (
                    ""
                  )}
                  <Form.Control
                    type="password"
                    value={passwordConfirm}
                    placeholder={t("commun.form.placeholder.placeholderMdpRegisterConfirm")}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    className="p-2 mt-3"
                  />
                  {error.passwordControl ? (
                    <div className="text-danger">{error.passwordControl} </div>
                  ) : (
                    ""
                  )}
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_GOOGLECATPCHA_KEY}
                    onChange={handleRecaptcha}
                    className="d-flex justify-content-center mt-3"
                  />
                  {!loader && (
                    <Button type="Submit" className="bg-secondary text-dark mt-3">
                      {t("commun.form.button.validerCompte")}
                    </Button>
                  )}
                  {loader && (
                    <div className="mt-3">
                      <ComponentLoader className="text-light" />
                    </div>
                  )}
                </>
              )}
            </Form>
            {errorRegister ? <div className="text-danger">{errorRegister}</div> : ""}
          </>
        )}
      </div>
    </Container>
  );
};
